<template>
  <div class="overview Overview.vue full-container">
    <div class="overview__content w100">
      <div class="section1 h100">

        <div class="section__content">
          <a href="javascript:void(0);" class="go-back" @click="goBack">
            <arrowBack class="inverted"></arrowBack>
          </a>

          <h1 class="title-primary text-center animated fadeInDown delay1000ms">
            Maravilha <span class="sub"> {{ guestName }}!</span> <br>
          </h1>

          <h2 class="title-primary text-inverted animated fadeInDown delay1000ms">
            Nossa cultura empresarial é absolutamente focada em resultados.
          </h2>


          <div class="abs animated fadeInDown delay1000ms">
            <div class="ctn" @click="goTo('.section2')">
              <div class="scroll-down"></div>
            </div>
          </div>
          <!-- /.abs -->


        </div>
        <!-- /.section__content -->

      </div>
      <!-- /.section1 -->
      <div class="section2 h100 hidden">
        <div class="video__ctn h100">
          <video id="bgvid" playsinline preload autoplay muted loop>
            <source src="/static/media/video3.mp4" type="video/mp4">
          </video>
        </div>
        <!-- /.video__ctn -->


        <div class="section__content">
          <div class="left h100" data-aos="fade" data-aos-offset="500">


            <div class="text-second">
              <!--<i class="arrow simple to-left"></i>-->

              <div class="padding">
                Acreditamos que a comunicação é um instrumento poderoso para resolver problemas de vendas, de imagem, de
                gestão e de motivação. Além disso, aqui na <span>Bold</span>, levamos criatividade à sério. Com boas
                ideias e objetivos claros, o retorno sobre o investimento é só uma questão de tempo.
              </div>
              <!-- /.padding -->
              <!--<i class="arrow simple"></i>-->

            </div>

            <!-- /.text-second -->
            <!-- /.arrow simple -->
            <!-- /.arrow -->


            <!--<div class="scroll-down"></div>-->
          </div>
          <!-- /.left -->

        </div>
        <!-- /.section-content -->
      </div>
      <!-- /.section2 -->

      <div class="section3 hidden">
        <div class="section__content">
          <h2 class="title-primary">Veja quem confia suas estratégias de marketing e comunicação à Bold:</h2>

          <div class="overview__brands">
            <ul>
              <li :key="n" v-for="n, index in parceiros" v-bind:class="{'paria': index > 27}">
                <img data-aos="fade-down" data-aos-offset="150" data-aos-once="true"
                     v-bind:src="'/static/media/partners/@2x/'+n+'@2x.png'" alt="Client">
              </li>
            </ul>
          </div>
          <!-- /.overview__brands -->
        </div>
        <!-- /.section__content -->
      </div>
      <!-- /.section3 -->

      <div class="section4 hidden">


        <h1 class="title-primary">
          <logoMinimal></logoMinimal>
          <span style="color:#fff;">Equipe</span>
          <logoCoda fill="#ffffff"></logoCoda>
        </h1>

        <!-- /.text-primary -->
        <div class="bosses" v-if="false">
          <div class="human hero" :key="item" v-for="item in bosses">
            <img src="/static/media/placeholder-human.png" alt="">
            <div class="description">
              <div class="name"><span>{{ item.nome }}</span></div>
              <div class="role">Diretor</div>
            </div>
            <!-- /.description -->
            <div class="sprite">
              <img alt="" onerror='this.src="/static/media/people/placeholder-sprite.jpg"'
                   v-bind:src="'/static/media/people/'+item.slug+'.png'">
            </div>
          </div>
          <!-- /.human -->
          <div class="clearfix"></div>

        </div>
        <!-- /.bosses -->

        <!-- /.clearfix -->

        <div class="staff">
          <div class="hero" :key="filePath(index)" v-for="{ nome, snome, pos }, index in orderedStaff"
               v-bind:class="{'paria': isParia(index)}" data-aos="fade-in" v-bind:data-aos-offset="50"
               data-aos-once="false">
            <img src="/static/media/placeholder-hero.png" alt="Hero"/>
            <div class="description">
              <div class="name">
                <span>{{ nome }}</span><span>{{ snome }}</span>
                <div class="role">{{ pos }}</div>
              </div>
            </div>
            <div class="sprite">
              <img
                onerror='this.src="/static/media/people/placeholder-sprite.jpg"'
                :src="filePath(index)" :alt="snome"/>
            </div>
            <!-- /.sprite -->
            <!-- /.description -->
          </div>
          <!-- /.hero -->
          <div class="clearfix"></div>
          <!-- /.clearfix -->
        </div>
        <!-- /.staff -->
        <div class="bottom-bar">
          <div class="container">
            <div class="left">

              <a href="javascript:void(0);" class="go-back" @click="goBack">
                <arrowBack class=""></arrowBack>
                <span>voltar</span>
              </a>

            </div>
            <div class="right">
              <a href="javascript:void(0);" @click="goToClientStage">
                <span>continuar</span>
                <!--<img src="/static/media/ico-continuar.svg" alt="continuar">-->
                <arrow></arrow>
              </a>
            </div>
          </div>
          <!-- /.container -->
        </div>
        <!-- /.bottom-bar -->
      </div>
      <!-- /.section4 -->

      <div class="clearfix"></div>
      <!-- /.clearfix -->

    </div>
    <!-- /.overview__content -->

  </div>

</template>

<script>

import arrowBack from '@/components/arrowBack.vue';
import logoMinimal from '../../assets/logo-minimal.svg';
import logoCoda from '../../assets/logo-coda.svg';
import arrow from '../../../static/media/ico-continuar.svg';
import aos from 'aos';
import exec from 'script-loader!trial-js/trial.min';
import slugify from 'slugify'

export default {
  name: 'Overview',
  components: {
    arrowBack,
    logoMinimal,
    logoCoda,
    arrow
  },
  data() {
    return {
      parceiros: [
        'atalaia',
        'atlantico',
        'batista-leal',
        'boa-vista',
        'corveta',
        'dental',
        'ecocharme',
        'ford-franca',
        'gov-pe',
        'greenmix',
        'hair-fly',
        'tambai',
        'jeep-radar',
        'locomotive',
        'luck',
        'palazzo',
        'pro-crianca',
        'renaut-lavie',
        'tecon',
        'yes',
        'marmorart',
        'max-plural',
        'nissan',
        'pharmapele',
        'emporio-da-luz',
        'real-derma',
        'summerville',
        'lojao-cabelereiro',
        'trois-beaute',
        'maremar-turismo',
        'organo',
        'ideiaria',
        'spa-beaute',
        'boris-berenstein',
        'kia-francar',
        'radar-ram',
        'labelle-citroen',
        'renault-la-vie',
        'arpoador',
        'labelle-peugeot',
        'renault-marlin',
        'botopremium',
        'roval',
        'cachoeira-fiat',
        'mavel-fiat',
        'sicredi',
        'chery-jcf',
        'mit-nami',
        'sunhome',
        'daf-nova',
        'nissan-marlin',
        'via-franca',
        'fity',
        'odontocompany',
        'vitabrasil',
        'grande-rio-fiat',
        'radar-fiat',
        'vrl',
        'ipanema-inn',
        'radar-jeep',
      ],
      bosses: [
        {
          nome: 'Halisson',
          snome: 'Barreto',
          pos: ''
        },
        {
          nome: 'Thiago',
          snome: 'Nascimento',
          pos: ''
        }
      ],

      staff: [
        {
          nome: 'Alexandre',
          snome: 'Antunes',
          pos: ''
        },
        {
          nome: 'Matheus',
          snome: 'Mendes',
          pos: ''
        },
        {
          nome: 'Pedro',
          snome: 'Anjos',
          pos: ''
        },
        {
          nome: 'Pedro',
          snome: 'Nascimento',
          pos: ''
        },
        {
          nome: 'Rafael',
          snome: 'Zurc',
          pos: ''
        },
        {
          nome: 'Samuel',
          snome: 'Barbosa',
          pos: ''
        },
        {
          nome: 'Thiago',
          snome: 'Alves',
          pos: ''
        },
        {
          nome: 'Williams',
          snome: 'Gomes',
          pos: ''
        },
        {
          nome: 'Cristina',
          snome: 'Rocha',
          pos: ''
        },
        {
          nome: 'Ricardo',
          snome: 'Nogueira',
          pos: ''
        },
        {
          nome: 'Rossana',
          snome: 'Freitas',
          pos: ''
        },
      ],
      pariaLimit: 0
    }
  },
  computed: {
    guestName() {
      return this.$store.getters.guestFirstName;
    },

    orderedStaff() {
      const {staff, bosses, shuffle} = this;

      return [...bosses, ...shuffle(staff)];
    }
  },

  mounted() {
    let $this = this;
    this.log('mounted: ' + this.$options.name);
    let isMobile = /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(navigator.userAgent);


    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'inverted');

    $('.h100').height(window.innerHeight + 'px');

    $(window).on('resize', function () {
      if (isMobile === false) {
        $('.h100').height(window.innerHeight + 'px');
        $('.section2 .left').attr('data-aos-offset', parseInt(window.innerHeight * 0.8));
      }
    });

    $('.section2 .left').attr('data-aos-offset', parseInt(window.innerHeight * 0.8));

    $(window).on('scroll', function () {
      if (isMobile === false) {
        let offset = $('.section2').offset().top - $(window).scrollTop();
        offset -= 60;

        let offset2 = $('.section4').offset().top - $(window).scrollTop();
        offset2 -= 60;

        if (offset2 > 0) {
          if (offset < 0) {
            $('.menu').removeClass('inverted');
          } else {
            $('.menu').addClass('inverted');
          }
        } else {
          $('.menu').addClass('inverted');
        }
      }

    });

    setTimeout(() => {
      $('.section2').removeClass('hidden');
      $('.section2,.section3,.section4').removeClass('hidden');

      // avoid multiple init
      if (!window.aos_started) {
        aos.init();
        window.aos_started = true;
      }

      // dirty hack to get the number of .heros per line
      let herosPerLines = Math.ceil(document.querySelector('.staff').offsetWidth / document.querySelector('.hero').offsetWidth);

      // console.log(herosPerLines);
      console.log(document.querySelector('.staff').offsetWidth);

      $this.pariaLimit = ($this.orderedStaff.length) - ($this.orderedStaff.length % herosPerLines);
    }, 1000);

  },
  beforeDestroy() {
    $(window).off('resize').off('scroll');
    Trial(".hero").off('within').off('leave');

  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    isParia(position) {
      return (position + 1) > this.pariaLimit;
    },
    goToClientStage() {
      this.$router.push('/client/stage')
    },
    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    goTo(selector) {
      $('html, body').animate({
        scrollTop: $(selector).offset().top
      }, 500);
    },

    filePath(id) {
      const {nome, snome} = this.orderedStaff[id];

      const fileName = [nome, snome].map(v => v.toLowerCase()).join('-');

      return `./static/media/people/${slugify(fileName)}.jpg`;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hero {
  opacity: 1;
}

.overview .section4 .staff {
  max-width: 1200px;
  display: flex;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/client/Overview.vue